import React from "react";
import cisco_assets from "../../assets/cisco_v4_light.svg";
import cisco_dark from "../../assets/cisco_v4_dark.svg";
import juniperLogo from "../../assets/juniper_v4_light.svg";
import juniper_dark from "../../assets/juniper_v4_dark.svg";
import paloalto_assets from "../../assets/paloalto3_v4_light.svg";
import paloalto_dark from "../../assets/paloalto4_v4_dark.svg";
import arista_assets from "../../assets/arista_v4_light.svg";
import arista_dark from "../../assets/arista_v4_dark.svg";
import fortinet_img from "../../assets/fortinet.svg";
import fortinet_scan_dark from "../../assets/fortinet-white-1.svg";
import ubuntu_white from "../../assets/ubuntu_white.svg";
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import windows_light from "../../assets/baseVersion/Windows_light.svg";
import windows_dark from "../../assets/baseVersion/Windows_dark.svg";
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
import awsLogo from "../../assets/baseVersion/aws.svg";
import awsLogoDark from "../../assets/baseVersion/AWS_DARK.svg";

export type VendorLogo = {
  src: string;
  alt: string;
  style?: React.CSSProperties;
};

export const getVendorLogo = (
  vendorName: string | undefined,
  isDarkMode: boolean
): VendorLogo | null => {
  const vendor = (vendorName || "").toLowerCase().trim().replace(/\s+/g, " ");
  const vendorCompact = vendor.replace(/\s+/g, "");

  if (vendor === "cisco" || vendorCompact === "cisco") {
    return {
      src: isDarkMode ? cisco_dark : cisco_assets,
      alt: "Cisco",
    };
  }
  if (vendor === "juniper" || vendorCompact === "juniper") {
    return {
      src: isDarkMode ? juniper_dark : juniperLogo,
      alt: "Juniper",
    };
  }
  if (
    vendor === "palo alto" ||
    vendor === "paloalto" ||
    vendorCompact === "paloalto" ||
    vendor.includes("palo")
  ) {
    return {
      src: isDarkMode ? paloalto_dark : paloalto_assets,
      alt: "Palo Alto",
    };
  }
  if (vendor === "arista" || vendorCompact === "arista") {
    return {
      src: isDarkMode ? arista_dark : arista_assets,
      alt: "Arista",
    };
  }
  if (vendor === "fortinet" || vendorCompact === "fortinet") {
    return {
      src: isDarkMode ? fortinet_scan_dark : fortinet_img,
      alt: "Fortinet",
      style: { width: "50px", height: "50px" } as React.CSSProperties,
    };
  }
  if (vendor === "ubuntu" || vendorCompact === "ubuntu") {
    return {
      src: isDarkMode ? ubuntu_dark : ubuntu_white,
      alt: "Ubuntu",
      style: { width: "70px", height: "40px" } as React.CSSProperties,
    };
  }
  if (vendor === "microsoft" || vendor.includes("windows")) {
    return {
      src: isDarkMode ? windows_dark : windows_light,
      alt: "Microsoft",
      style: isDarkMode
        ? {
            width: "100px",
            height: "55px",
            objectFit: "contain",
            objectPosition: "left",
            marginLeft: "-14px",
          }
        : { width: "70px", height: "40px" },
    };
  }
  if (vendor === "redhat" || vendorCompact === "redhat") {
    return {
      src: isDarkMode ? redhat_dark : redhat_light,
      alt: "Red Hat",
      style: { width: "70px", height: "40px" } as React.CSSProperties,
    };
  }
  if (vendor === "debian" || vendorCompact === "debian") {
    return {
      src: isDarkMode ? debian_dark : debian,
      alt: "Debian",
      style: { width: "70px", height: "40px" } as React.CSSProperties,
    };
  }
  if (vendor === "huawei" || vendorCompact === "huawei") {
    return {
      src: isDarkMode ? huawei_dark : huawei_light,
      alt: "Huawei",
      style: { width: "70px", height: "40px" } as React.CSSProperties,
    };
  }
  if (vendor === "mikrotik" || vendorCompact === "mikrotik") {
    return {
      src: isDarkMode ? mikrotik_dark : mikrotik,
      alt: "MikroTik",
      style: { width: "90px", height: "35px", objectFit: "contain" } as React.CSSProperties,
    };
  }
  if (vendor === "edgecore" || vendorCompact === "edgecore") {
    return {
      src: edgecore_logo,
      alt: "Edgecore",
      style: {
        width: "80px",
        height: "30px",
        objectFit: "contain",
        filter: isDarkMode ? "brightness(0) invert(1)" : "none",
      } as React.CSSProperties,
    };
  }
  if (
    vendor === "tp-link" ||
    vendorCompact === "tp-link" ||
    vendor === "tplink" ||
    vendorCompact === "tplink"
  ) {
    return {
      src: isDarkMode ? tplink_dark : tplink_light,
      alt: "TP-Link",
      style: { width: "80px", height: "30px", objectFit: "contain" } as React.CSSProperties,
    };
  }
  if (vendor === "apple" || vendorCompact === "apple") {
    return {
      src: isDarkMode ? apple_dark : apple_img,
      alt: "Apple",
      style: { width: "40px", height: "40px", objectFit: "contain" } as React.CSSProperties,
    };
  }
  if (vendor === "dell" || vendorCompact === "dell" || vendor.includes("dell")) {
    return {
      src: dell_logo,
      alt: "Dell",
      style: { width: "40px", height: "40px", objectFit: "contain" } as React.CSSProperties,
    };
  }
  if (
    vendor === "syrotech" ||
    vendorCompact === "syrotech" ||
    vendor.includes("syrotech")
  ) {
    return {
      src: isDarkMode ? syrotech_dark : syrotech_light,
      alt: "Syrotech",
      style: {
        width: "90px",
        height: "32px",
        objectFit: "contain",
      } as React.CSSProperties,
    };
  }
  if (
    vendor === "aws" ||
    vendorCompact === "aws" ||
    vendor === "amazon web services" ||
    vendorCompact === "amazonwebservices" ||
    vendor.includes("amazon") ||
    vendor.includes("aws")
  ) {
    return {
      src: isDarkMode ? awsLogoDark : awsLogo,
      alt: "AWS",
      style: {
        width: "40px",
        height: "22px",
        objectFit: "contain",
      } as React.CSSProperties,
    };
  }
  return null;
};
